import type { WebViewDto } from '@/api/webs'
import type { WebTabKey } from '@/hooks/useWebTabRouter'
import { OnlineEventPanel } from '../panels/OnlineEventPanel'
import { DownloadPanel } from '../panels/DownloadPanel'
import { MeetingPanel } from '../panels/MeetingPanel'
import { DemoPanel } from '../panels/DemoPanel'

interface Props {
  web: WebViewDto
  onPatchWeb: (patcher: (prev: WebViewDto) => WebViewDto) => void
  syncing?: boolean
  routeToTab?: (tab: WebTabKey) => void
}

// Hosts the type-specific panels (without top-level settings now).
export function WebDetailsTab({ web, onPatchWeb, syncing, routeToTab }: Props) {
  const type = (web.Type || '').toLowerCase()
  const isOnlineEvent = type.includes('online') || !!web.OnlineEvent
  const isDownload = type.includes('download') || !!web.Download
  const isMeeting = web.Type === 'Meeting'
  const isDemo = web.Type === 'Demo'

  return (
    <div className="space-y-6">
      {isOnlineEvent && <OnlineEventPanel web={web} onPatchWeb={onPatchWeb} isSignedOff={web.ApprovalStatus === 'Signed Off'} syncing={syncing} routeToTab={routeToTab} />}
      {isDownload && !isOnlineEvent && <DownloadPanel web={web} onPatchWeb={onPatchWeb} isSignedOff={web.ApprovalStatus === 'Signed Off'} routeToTab={routeToTab} />}
      {isMeeting && !isOnlineEvent && !isDownload && <MeetingPanel web={web} onPatchWeb={onPatchWeb} isSignedOff={web.ApprovalStatus === 'Signed Off'} routeToTab={routeToTab} />}
      {isDemo && !isOnlineEvent && !isDownload && <DemoPanel web={web} onPatchWeb={onPatchWeb} isSignedOff={web.ApprovalStatus === 'Signed Off'} routeToTab={routeToTab} />}
      {!isOnlineEvent && !isDownload && !isMeeting && !isDemo && (
        <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6 shadow-sm text-sm text-slate-600 dark:text-slate-300">
          No type-specific details available for this web.
        </div>
      )}
    </div>
  )
}
